module.exports = __webpack_public_path__ + "28b67065/img/comments-icon.fdec7fdb.svg";